import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const ProvinceSelect = ({
  name,
  value,
  label,
  onChange,
  provinceList,
  error,
  helperText,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        id="province-select-label"
        sx={{
          background: "#fff",
          padding: "0 10px",
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId="province-select-label"
        id="province-select"
        name={name}
        value={value}
        onChange={onChange}
        error={error}
      >
        {provinceList.map((x) => (
          <MenuItem key={x.id} value={x.id}>
            {x.title}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default ProvinceSelect;
